export default __webpack_public_path__ + "static/media/shop-not-found.587ef8d6.svg";